import { RouteRecord } from 'vue-router';
export { default as component } from './MusicIndex.vue';

export const children: RouteRecord[] = [

];
